import { render, staticRenderFns } from "./ChangeLog.vue?vue&type=template&id=2603ddbc&scoped=true"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"
import style0 from "./ChangeLog.vue?vue&type=style&index=0&id=2603ddbc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603ddbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2603ddbc')) {
      api.createRecord('2603ddbc', component.options)
    } else {
      api.reload('2603ddbc', component.options)
    }
    module.hot.accept("./ChangeLog.vue?vue&type=template&id=2603ddbc&scoped=true", function () {
      api.rerender('2603ddbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/ChangeLog.vue"
export default component.exports